import { lazy, Suspense } from 'react';

const MiniCart = lazy(() => import('./miniCart'));

const MiniCartLazyLoad = props => {
  return (
    <Suspense>
      <MiniCart {...props} />
    </Suspense>
  );
};

export default MiniCartLazyLoad;
